__turbopack_context__.v({
  "email-input": "personal-details-module-scss-module__wqZ0UG__email-input",
  "input-group": "personal-details-module-scss-module__wqZ0UG__input-group",
  "inputs": "personal-details-module-scss-module__wqZ0UG__inputs",
  "inputs-section": "personal-details-module-scss-module__wqZ0UG__inputs-section",
  "intro-message": "personal-details-module-scss-module__wqZ0UG__intro-message",
  "intro-message-header": "personal-details-module-scss-module__wqZ0UG__intro-message-header",
  "job-title-input": "personal-details-module-scss-module__wqZ0UG__job-title-input",
  "legal-disclaimer": "personal-details-module-scss-module__wqZ0UG__legal-disclaimer",
  "legal-disclaimer-link": "personal-details-module-scss-module__wqZ0UG__legal-disclaimer-link",
  "name-inputs": "personal-details-module-scss-module__wqZ0UG__name-inputs",
  "org-name-input": "personal-details-module-scss-module__wqZ0UG__org-name-input",
  "personal-details-page": "personal-details-module-scss-module__wqZ0UG__personal-details-page",
  "side-section-content": "personal-details-module-scss-module__wqZ0UG__side-section-content",
});
